import { useEffect, useReducer } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HighChart from "../HighChart";
import { validId } from "../../helpers/utils";
import styles from "./ModalSurveyQuestionResults.module.css";

const reducer = (state, action) => {
    switch (action.type) {
        case ACTION.NEW_CHART_DATA:
            let dataLoaded = false;
            if (action.payload.type === "multiple choice") {
                if (action.payload.chartType === "nested pie chart") {
                    dataLoaded = (action.payload.responses.overall.length > 0);
                } else {
                    dataLoaded = (action.payload.responses.length > 0);
                }
            } else if (action.payload.type === "text") {
                dataLoaded = (action.payload.responses.length > 0);
            } else if (action.payload.type === "numeric") {
                dataLoaded = (Object.keys(action.payload.results).length > 0);
            } else if (action.payload.type === "matrix") {
                dataLoaded = ((action.payload.responses.length > 0) && (action.payload.statements.length > 0) && (action.payload.answerChoices.length > 0));
            } else if (action.payload.type === "constant sum") {
                dataLoaded = (action.payload.responses.length > 0);
            }

            const question = action.payload.question;
            const fullQuestion = action.payload.fullQuestion;
            const surveyId = action.payload.surveyId;

            return { ...state, chartData: { ...action.payload }, question, fullQuestion, surveyId, dataLoaded: dataLoaded };
        default:
            console.log(`unhandled action.type: ${action.type}`)
    }
}

const ACTION = {
    NEW_CHART_DATA: "newChartData"
}

const ModalSurveyQuestionResults = ({ surveyQuestionId, onCloseDialog }) => {

    const axiosPrivate = useAxiosPrivate();

    // const chartContainerRef = useRef();

    const [state, dispatch] = useReducer(reducer, {
        chartData: {},
        dataLoaded: false
    });

    // const [chartHeight, setChartHeight] = useState(0);
    // const [gridHeight, setGridHeight] = useState(0);

    // useEffect(() => {

    //     const element = chartContainerRef?.current;

    //     if (!element) return;

    //     const observer = new ResizeObserver(() => {
    //         // setGridSize(element.clientHeight);

    //         const width = element.offsetWidth ?? 0;
    //         const height = element.offsetHeight ?? 0;
    //         const ratio = width === 0 ? 0 : height / width;
    //         setChartHeight(ratio);
    //         setGridHeight(Math.min(height, width));

    //     });


    //     observer.observe(element);
    //     return () => {
    //         console.log("observer.disconnect()");
    //         observer.disconnect();
    //     };

    // }, [chartContainerRef, state.dataLoaded]);

    useEffect(() => {

        // This effect is triggered the first time the page loads, or if the surveyQuestionId changes

        let isMounted = true;

        const controller = new AbortController();

        const getQuestion = async () => {

            try {
                const response = await axiosPrivate.get(`/surveyQuestions/${surveyQuestionId}/results`,
                    {
                        signal: controller.signal
                    });
                if (isMounted) {
                    dispatch({
                        type: ACTION.NEW_CHART_DATA, payload: { ...response.data }
                    });
                }
            } catch (err) {
                if (isMounted) {
                    console.error(err);
                    // if (err.response?.status === 403) {
                    //     navigate('/login', { state: { from: location }, replace: true });
                    // }
                }
            }
        }

        if (validId(surveyQuestionId)) {
            getQuestion();
        }

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [surveyQuestionId]) // eslint-disable-line react-hooks/exhaustive-deps

    if (!state.dataLoaded) {
        return null;
    }

    console.log(state.chartData);

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.surveyQuestionResultsContainer}>
                <h3>{state.fullQuestion}</h3>
                {/* <div className={styles.chartContainer} ref={chartContainerRef}>
                    <HighChart chartData={state.chartData} chartHeight={formatPercent(chartHeight * 100, 4)} gridHeight={gridHeight} />
                </div> */}
                <div className={styles.chartContainer}>
                    <HighChart chartData={state.chartData} chartHeight={400} />
                </div>
                <button className="close" onClick={onCloseDialog}></button>
            </div>
        </div>
    );

};

export default ModalSurveyQuestionResults;